export default {
    name: 'B2',
    lineHeight: '30px',
    lineHeightDesktop: '40px',
  }